<!-- MFITTで予約取り消し後に購入に進もうとした場合(自動予約取り消し時間前後で予約確認画面を開いていると、この操作ができる想定) -->
<template>
  <ItemDialog ref="canNotPurchaseAfterCanceled" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        購入期限を過ぎたため、この予約は取り消されており、購入することはできません。大変恐れ入りますが、購入をご希望の場合は、再度「特急ロマンスカー予約・購入」のメニューからご希望の列車をお選びください。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotPurchaseAfterCanceled",
  setup() {
    const canNotPurchaseAfterCanceled = ref(null);

    const openDialog = () => {
      canNotPurchaseAfterCanceled.value.open();
    };

    const closeDialog = () => {
      canNotPurchaseAfterCanceled.value.close();
    };

    return {
      canNotPurchaseAfterCanceled,
      openDialog,
      closeDialog,
    };
  },
};
</script>
